import React, { useContext } from 'react';
import { CountryCode } from '@dayetopia/library/types';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { Context } from '@components/Context';
import { P } from '@components/shared/Typography';

interface Props {
  text?: string;
}

export default function FooterFDA({ text }: Props) {
  const { t } = useTranslation();
  const { state } = useContext(Context);
  const { country } = state;

  // TODO: to improve with https://app.asana.com/0/1199876167829379/1209201962478367/f
  const localisedText = country === CountryCode.US ? t('components.fda-eval-us') : t('components.fda-eval');

  return (
    <FDA>
      <PStyled>{text || localisedText}</PStyled>
    </FDA>
  );
}

const FDA = styled.div`
  background: #c4e2bf;
  width: 100%;
  padding: 20px;
  margin: auto;
`;

const PStyled = styled(P)`
  width: fit-content;
  margin: 0 auto;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0;
  text-align: center;
  max-width: 810px;
`;
